module.exports = __webpack_public_path__ + "img/gif.43887e5c.svg";